
"use client";

import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {Locale, usePathname, routing} from "@/i18n/routing";
import {LocaleItem} from "@/types/contentful/locale-item";
import Image from "next/image";
import Link from "next/link";
import Cookies from "js-cookie";


interface Props {
    localeDropdownItems:LocaleItem[],
    queryParams:Record<string,string>
}

function AddQueryStringParams(url: string, queryParams: Record<string, string>): string {

    if (queryParams) {
        const newUrl = new URL(url, window.location.origin);
        Object.entries(queryParams).forEach(([key, value]) => {
            newUrl.searchParams.set(key, value);
        });
        return newUrl.toString().replace(window.location.origin, ""); // Remove the origin for relative URLs
    }

    return url;
  }

function AddLocaleToUrl(locale: string, queryParams?: Record<string, string>): string {
    const currentUrl = usePathname();
  
    // Check if the URL already has a locale
    const urlParts = currentUrl.split("/");
    const loc = urlParts[1] as Locale;
    if (urlParts[1] && routing.locales?.includes(loc)) {
      // Replace existing locale
      urlParts[1] = locale;
      return AddQueryStringParams(urlParts.join("/"), queryParams || {});
    } 
      // Add locale
      return AddQueryStringParams(`/${locale}${currentUrl}`, queryParams || {});
    
  }

  

const LocaleDropdownLinkList = ({ localeDropdownItems, queryParams}: Props) => (
  
            <List data-testid="locale-dropdown-list"
              sx={{paddingTop:0,
                  paddingBottom:0,
                  margin:0
              }}>
                    {localeDropdownItems.map((item) => 

                           
                              <ListItem
                                      key={item.id}
                                      data-testid={`locale-option-${item.id}`}
                                      sx={{
                                        border: "1px solid",
                                        borderColor: "divider",
                                        backgroundColor: "background.default",
                                        padding:0,
                                        margin:0,
                                        color:"text.secondary"
                                    }}
                              >
                            
                                    <Link 
                                        href={AddLocaleToUrl(item.id, queryParams)} 
                                        prefetch={false}
                                        onClick={() => {
                                            // Set legacy site-language cookie with appropriate values
                                            const countrySuffix = item.id.split("-")[1]?.toLowerCase();
                                            const siteId = `collette-${countrySuffix}`;
                                            
                                            // Special case for en-us locale: language should be just 'en'
                                            const langValue = item.id === "en-us" ? "en" : item.id.toLowerCase();
                                            
                                            // Legacy cookie format: site=collette-ca&language=en-CA
                                            
                                            // Base cookie options for all environments
                                            const cookieOptions: {
                                                expires: number;
                                                path: string;
                                                sameSite: "strict";
                                                secure: boolean;
                                                domain?: string;
                                            } = {
                                                expires: 365,
                                                path: "/",
                                                sameSite: "strict",
                                                secure: true
                                            };
                                            
                                            // Add domain specific settings based on hostname
                                            if (typeof window !== "undefined") {
                                                const {hostname} = window.location;
                                                
                                                if (hostname.includes("gocollette.com")) {
                                                    // Production environment
                                                    cookieOptions.domain = ".gocollette.com";
                                                } else if (hostname.includes("internal.collette.cloud")) {
                                                    // Development or QA environments
                                                    cookieOptions.domain = ".internal.collette.cloud";
                                                }
                                                // For localhost or other environments, don't set domain
                                            }
                                            
                                            Cookies.set("site-language", `site=${siteId}&language=${langValue}`, cookieOptions);
                                        }}
                                    >
                                        <ListItemButton 
                                                          data-testid={`locale-button-${item.id}`}
                                                          sx={{height:30, 
                                                                "&:hover": {
                                                                    backgroundColor: "background.warm"
                                                    }}} component="a">
                                        
                                            <ListItemIcon 
                                                  data-testid={`locale-icon-${item.id}`}
                                                    sx={{paddingRight:0, minWidth:20}}>
                                                <Image src={item.icon}
                                                        alt={item.alt}
                                                        width={16}
                                                        height={16} />
                                                        
                                            </ListItemIcon>
                                            <ListItemText 
                                                    data-testid={`locale-text-${item.id}`}
                                                    primary={item.label} />
                                            
                                        
                                        </ListItemButton>

                                    </Link>
                                </ListItem>
                    )
                  }        
                    
            </List>
        

    
    );


export default LocaleDropdownLinkList;